// extracted by mini-css-extract-plugin
export default {"quantityLabel":"styles_quantityLabel__h36Ry","iconTooltip":"styles_iconTooltip__pgxWX","required":"styles_required__x63sH"};